import React, { useEffect } from 'react';
import {
  CContainer,
  CButton,
} from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import OrderStatusTable from '../../components/OrderStatusTable/OrderStatusTable';
import {
  getOrderStatusRequestAction,
  sortOrderStatusHistorySortData,
  sortingOrderStatusHistoryAction,
} from '../../store/orderStatus/orderStatusActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import './OrderStatus.scss';

const OrderStatus = (props) => {
  const {
    orderStatusHistorySortData,
    setSortData,
    sortingOrderStatusHistory,
    orderStatusData,
    orderStatusList,
    getOrderStatusRequest,
    user,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    // Sayfa yüklendiğinde order status verilerini çek
    getOrderStatusRequest({
    });
  }, []);

  useEffect(() => {
    if (orderStatusHistorySortData) {
      getOrderStatusRequest({
        OrderStatusId: null
      });
    }
  }, [orderStatusHistorySortData]);

  function changeSortType(sortType) {
    const neworderStatusHistorySortData = { ...orderStatusHistorySortData, sortType };
    setSortData(neworderStatusHistorySortData);
    sortingOrderStatusHistory();
  }

  function changeSortKey(sortKey) {
    const neworderStatusHistorySortData = { ...orderStatusHistorySortData, sortKey };
    setSortData(neworderStatusHistorySortData);
    sortingOrderStatusHistory();
  }

  const getDebugUserInfo = () => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const sessionUserId = localStorage.getItem('sessionUserId');
    
    return {
      sessionUserId: sessionUserId || userData?.sessionUserId,
      username: userData?.username,
      fullName: userData?.fullName,
      userStatus: userData?.userStatus
    };
  };

  const handleCreateOrder = () => {
    navigate('/order-status/create');
  };

  return (
    <div className="order-status-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('orderStatus')}</div>
        
        <OrderStatusTable 
          changeSortType={changeSortType}
          changeSortKey={changeSortKey}
          orderStatusHistorySortData={orderStatusHistorySortData}
          orderStatusList={orderStatusList}
          orderStatusData={orderStatusData}
        />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-status-fab"
        onClick={handleCreateOrder}
        title={t('createNewOrder')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orderStatusData: state.orderStatusReducer.orderStatusData,
    orderStatusList: state.orderStatusReducer.orderStatusList,
    orderStatusHistorySortData: state.orderStatusReducer.orderStatusHistorySortData,
    isLoading: state.loadingReducer.isLoading,
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSortData: (payload) => {
      dispatch(sortOrderStatusHistorySortData(payload));
    },
    sortingOrderStatusHistory: (payload) => {
      dispatch(sortingOrderStatusHistoryAction(payload));
    },
    getOrderStatusRequest: (payload) => {
      dispatch(getOrderStatusRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderStatus); 